import React from 'react';
import { ZdsDivider } from '@zig-design-system/ui-components-react';
import Translation from '../Translation';
const NoResults = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "zds-headline-md zds-margin-top-6" },
            React.createElement(Translation, { item: "tx_zigsitepackage.search.noResult.title" })),
        React.createElement(ZdsDivider, null),
        React.createElement("div", { className: "zds-headline-xs zds-padding-top-3" },
            React.createElement(Translation, { item: "tx_zigsitepackage.search.noResult.searchTips" })),
        React.createElement("ul", null,
            React.createElement("li", null,
                React.createElement(Translation, { item: "tx_zigsitepackage.search.noResult.firstTip" })),
            React.createElement("li", null,
                React.createElement(Translation, { item: "tx_zigsitepackage.search.noResult.secondTip" })),
            React.createElement("li", null,
                React.createElement(Translation, { item: "tx_zigsitepackage.search.noResult.thirdTip" }))),
        React.createElement("p", null,
            React.createElement(Translation, { item: "tx_zigsitepackage.search.noResult.contact" })),
        React.createElement(ZdsDivider, null)));
};
export default NoResults;
